import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { dripKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useCreateDrip = () => {
    const additional = useQueryRequestParams();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => axios.post(markUrl('drips/create/'), body, additional),
        onSuccess: (response) => {
            queryClient.setQueryData(dripKeys.detail(response.data.drip_id), response);
            return queryClient.invalidateQueries({ queryKey: dripKeys.list() });
        }
    });
};
export default useCreateDrip;
